import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { BzRadioGroup, type BzRadioValue } from './bz-radio-group';

/**
 * One option inside a `bz-radio-group`. Must be used inside a group — the
 * group owns the value, so a standalone radio has nothing to write to.
 */
@Component({
  selector: 'bz-radio',
  templateUrl: './bz-radio.html',
  styleUrl: './bz-radio.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzRadio {
  readonly value = input.required<BzRadioValue>();

  /** Disables this option alone. The whole group can also be disabled. */
  readonly disabled = input(false);

  /**
   * Accessible name for the control when nothing is projected as a visible
   * label. Without it a bare radio has no name at all and fails an
   * AXE check — there is no text for a screen reader to read.
   */
  readonly ariaLabel = input('');

  protected readonly group = inject(BzRadioGroup);

  protected readonly checked = computed(() => this.group.value() === this.value());
  protected readonly isDisabled = computed(() => this.disabled() || this.group.disabled());
}
